// NATIVE
import React, { useEffect, useState } from 'react';

// INSTALLED
import { Button, Divider } from '@mui/material';
import { BreadCrumbsAndTitle } from '../../../components/generics/BreadCrumbsAndTitle';

// CUSTOM
import { mtDividerUpTable } from '../../../commons';
import { hasPemissions } from '../../../commons/utils';
import { alertInformativo } from '../../../commons/texts';
import { AlertsInformativos } from '../../../components/generics/AlertsInformativos';
import { CreateDialogTerminalDescansos } from '../../../components/modals/terminal/terminal-descansos';
import { TableEmployeeTerminalDescansos } from '../../../components/tables/TableEmployeeTerminalDescansos';

export const TerminalDescansos = () => {
  // USE STATE
  const [modalCreate, setModalCreate] = useState(false);
  const [canCreate, setCanCreate] = useState<boolean>(false);

  // USE EFFECT
  useEffect(() => {
    hasPrmissionsCreate();
  }, []);

  // CONST FUNCTIONS
  const hasPrmissionsCreate = async () => {
    const hasPermissions = await hasPemissions(
      'modulo.configuracion',
      'modulo.terminalesdescanso',
      'create'
    );

    if (hasPermissions) {
      setCanCreate(true);
    }
  };

  // FUNCTIONS OPEN MODALS
  const openModal = () => {
    setModalCreate(true);
  };

  const handleCloseModalCrear = () => {
    setModalCreate(false);
  };

  return (
    <div>
      <BreadCrumbsAndTitle
        title="Listado Terminal Empleados Descansos"
        mainModule="configuracion"
        parent="Listado Terminal Empleados Descansos"
        action=""
      />

      {canCreate && (
        <div style={{ display: 'flex', justifyContent: 'end' }}>
          <Button variant="contained" sx={{ marginBottom: 3 }} onClick={openModal}>
            Crear Terminal Descansos
          </Button>
        </div>
      )}

      <AlertsInformativos
        type={'info'}
        title={'info'}
        content={alertInformativo.employeeTerminalDescansos}
      />
      <Divider sx={{ marginBottom: mtDividerUpTable }} />
      <CreateDialogTerminalDescansos
        open={modalCreate}
        handleCloseModalCrear={handleCloseModalCrear}
      />

      <TableEmployeeTerminalDescansos />
    </div>
  );
};
